// extracted by mini-css-extract-plugin
export var banner = "index-module--banner--AuZNG";
export var cardGroup = "index-module--cardGroup--kd3lG";
export var containerBox = "index-module--containerBox--9vqG2";
export var primaryButton = "index-module--primaryButton--8Hp8c";
export var showPage = "index-module--showPage--I2sv8";
export var smallBox = "index-module--smallBox--Z+HN1";
export var smallBoxContainer = "index-module--smallBoxContainer--B2R32";
export var smallItem = "index-module--smallItem--cVP2C";